// Simple cookie utilities used by the Cookie Consent modal and telemetry

export function setCookie(name, value, days) {
  const expires = (() => {
    if (!days) return "";
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    return "; expires=" + date.toUTCString();
  })();
  const path = "; path=/";
  document.cookie = `${name}=${value || ""}${expires}${path}`;
}

export function setHttpOnlyCookie(name, value, days) {
  // Note: HTTP-only cookies cannot be set from client-side JavaScript
  // This function is a placeholder for server-side implementation
  // The actual implementation should be done on the server side
  console.warn(`HTTP-only cookie ${name} cannot be set from client-side. Server-side implementation required.`);

  // For now, we'll set a regular cookie as fallback
  setCookie(name, value, days);
}

export function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split("; ");
  for (let i = 0; i < ca.length; i++) {
    const c = ca[i];
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
}
